import axios from "../axios";
import Axios from "axios";
import { useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";

export const uploadImage = async (file) => {
  var formData = new FormData();
  formData.append("media", file);
  try {
    const { data } = await axios.post("/auth/uploadImage", formData);

    return data;
  } catch (error) { }
};

export const extractDate = (e) => {
  if (e) {
    // let date = new Date(e).toLocaleDateString();
    let date = moment(e).format('L, LT')
    return date;
  } else {
    return "N/A";
  }
};

export const extractOnlyDate = (e) => {
  if (e) {
    // let date = new Date(e).toLocaleDateString();
    let date = moment(e).format('L')
    return date;
  } else {
    return "N/A";
  }
};

export const extractOnlyMonthYear = (e) => {
  if (e) {
    return moment(e).format('MMMM YYYY'); //  e.g., April 2025
  } else {
    return "N/A";
  }
};


export const getDeviceId = () => {
  let deviceId = localStorage.getItem('deviceId');
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem('deviceId', deviceId);
  }
  return deviceId;
}






export const maskToken = (token) => {
  if (token && token.length > 8) {
    const firstPart = token.slice(0, 4); // First 4 characters
    const lastPart = token.slice(-4); // Last 4 characters
    return `${firstPart}****${lastPart}`; // Combine with 4 asterisks
  }
  return "---"; // Return placeholder if token is invalid or too short
};

export const maskSocialSecurityNumber = (ssnLast4, socialSecurityNumber) => {
  // Prioritize ssnLast4, if available, else fall back to socialSecurityNumber
  const ssn = ssnLast4 || socialSecurityNumber;
  if (ssn) {
    return `*****${ssn.slice(-4)}`; // Return the last 4 digits with asterisks
  }
  return "N/A"; // Default if SSN is not valid or missing
};


export async function handleImageUpload(file) {
  // const [progress, setProgress] = useState(0);
  const formData = new FormData();
  formData.append("media", file);

  const config = {
    baseURL: "http://35.172.10.141:4000/",
    headers: {
      "Content-Type": "multipart/form-data",
      accessToken: localStorage.getItem("accessToken"),
    },
    onUploadProgress: (progressEvent) => {
      const progress = (progressEvent.loaded / progressEvent.total) * 50;
      // setProgress(progress);
      console.log(progressEvent.loaded);
      console.log(progress);
    },
    onDownloadProgress: (progressEvent) => {
      const progress = 50 + (progressEvent.loaded / progressEvent.total) * 50;
      console.log(progress);
      // setProgress(progress);
    },
  };
  try {
    const { data } = await Axios.post("/user/uploadImage", formData, config);
    console.log(data);

    return data.path;
  } catch (err) {
    return err;
  }
}

export const subadminAccessChange = async (navigate) => {
  const subadminData = JSON.parse(localStorage.getItem("userData")) || JSON.parse(sessionStorage.getItem("userData"));

  try {
    const { data } = await axios.post(`/accessChangeDetails?subAdminId=${subadminData?._id}`, {
      Email: "admin@gmail.com"
    });

    localStorage.setItem("userData", JSON.stringify(data?.data));

    // Check if userType is subAdmin
    if (data?.data?.userType == "subAdmin") {
      const modulePermission = data?.data?.adminpermissions?.modules;

      const allowedModule = modulePermission.find(module =>
        Object.values(module.permissions).some(permission => permission === true)
      );
      console.log("object", allowedModule)

      if (allowedModule) {
        // Map moduleName to route
        const moduleRoutes = {
          "Dashboard": "dashboard",
          "User Management": "userManagement",
          "Skill Management": "skillsManagement",
          "Blacklist Word Management": "blockManagement",
          "Commission Settings": "commissionSettings",
          "Gigs Management": "gigsManagement",
          "reported Gig Management": "reportedGigManagement",
          "Payment Management": "paymentManagement",
          "CMS Management": "cmsCondition",
          "Notification Management": "notificationManagement",
          "Leader board": "leaderboardManagement",
          "Ticket Management": "ticketManagement",
          "Feedback Management": "feedbackManagement"
        };
        let firstRoute = moduleRoutes[allowedModule?.moduleName]

        navigate(`/${firstRoute}`);
        window.location.reload();
      } else {
        navigate("/dashboard");
      }
    } else {
      navigate("/dashboard");
    }
  } catch (error) {
    console.log("ErrorSubadminAccessChange", error.response)
    if (error.response.status == 901) {
      toast.error(`${error.response.data?.message}`, {
        position: "top-right",
      });
    }
  }
};


// This function use for Ip 

export async function getPublicIP() {
  // optional — uses a public service. Remove if you don't want external call.
  try {
    const r = await fetch('https://api.ipify.org?format=json');
    if (!r.ok) throw new Error('ip fetch failed');
    const j = await r.json();
    return j.ip; // public IP string
  } catch (e) {
    console.warn('public IP lookup failed', e);
    return null;
  }
}

// This function use for Timezone
export async function getTimezone() {
  // returns IANA timezone if available: "Asia/Kolkata"
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch (e) {
    return null;
  }
}

// This function use for Location
export async function getGeoLocation() {
  // try browser geolocation (high accuracy if user allows)
  if (!('geolocation' in navigator)) return null;
  return new Promise((res) => {
    navigator.geolocation.getCurrentPosition(
      pos => res({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
      err => {
        console.warn('geolocation denied/failed', err);
        res(null);
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  });
}

export async function getAddressFromLatLng(lat, lon) {
  const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`;

  const res = await fetch(url, {
    headers: { 'User-Agent': 'your-app-name' }
  });

  const data = await res.json();
  return data;
}
